import { render, staticRenderFns } from "./BPIdLayout.vue?vue&type=template&id=3cc71556"
import script from "./BPIdLayout.vue?vue&type=script&lang=js"
export * from "./BPIdLayout.vue?vue&type=script&lang=js"
import style0 from "./BPIdLayout.vue?vue&type=style&index=0&id=3cc71556&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports